import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

import type { ComponentProps } from '~/chords/ComponentProps';
import { getClassNameOverride } from '~/chords/getClassNameOverride';
import { Scrollbars } from '~/chords/Scrollbars';
import { cn } from '~/lib/cn';

interface SlideOutBodyProps
  extends Omit<
    Dialog.DialogDescriptionProps &
      ComponentProps<HTMLAttributes<HTMLDivElement>>,
    'className'
  > {
  children: ReactNode;
  scrollable?: boolean;
}

export const SlideOutBody = forwardRef<HTMLDivElement, SlideOutBodyProps>(
  ({ children, scrollable = true, ...props }, ref) => {
    const className = getClassNameOverride(props, 'SlideOut.Body');

    const content = (
      <div
        className={cn(
          'h-full grow overflow-y-auto overscroll-y-contain px-lg py-md',
          className,
        )}
      >
        {children}
      </div>
    );

    return (
      <Dialog.Description ref={ref} {...props} asChild>
        {scrollable ? <Scrollbars asChild>{content}</Scrollbars> : content}
      </Dialog.Description>
    );
  },
);

SlideOutBody.displayName = 'SlideOut.Body';
